export default {"src":"/_next/static/media/businessAutomateControl.d2f97914.svg","height":30,"width":23,"blurWidth":0,"blurHeight":0};